@if (chartOption) {
  <div echarts
    [options]="chartOption"
    [merge]="chartOption"
    [ngClass]="chartClass"
    [autoResize]="true"
    [loading]="!chartOption"
  (chartInit)="onEchartInit($event)"></div>
}